/**
 * viewerId.js — anonymous, stable, per-browser identifier.
 *
 * Used by the open-ping endpoint to dedupe "the recipient reloaded the
 * link" from "two different recipients opened the same card". Cheap, no
 * server registration, no PII.
 *
 * Stored in localStorage under `moodcard.viewer.id`.
 */
const KEY = "moodcard.viewer.id";

function _uuid() {
    // crypto.randomUUID is available in all modern browsers we ship to.
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    // Fallback — sufficient for de-duplication purposes (not for security).
    return `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

export function getViewerId() {
    if (typeof window === "undefined") return null;
    try {
        let id = window.localStorage.getItem(KEY);
        if (!id) {
            id = _uuid();
            window.localStorage.setItem(KEY, id);
        }
        return id;
    } catch {
        // localStorage blocked (private mode, embedded contexts) — return a
        // fresh ID anyway; ping will still record, just may double-count
        // for this single session. Acceptable degraded behaviour.
        return _uuid();
    }
}
